// extracted by mini-css-extract-plugin
module.exports = {"wrapper-Default":"style_wrapper-Default__V9l07","wrapper-Small":"style_wrapper-Small__JPlkY"};